import { CountryPicker } from "@jugl-web/ui-components";
import { useToast, useTranslations } from "@jugl-web/utils";
import countries from "countries-phone-masks";
import { Country } from "@jugl-web/ui-components/cross-platform/PhoneInput/types";
import { useMemo } from "react";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { WorkspaceTile } from "../WorkspaceTile";

export const WorkspaceCountry = () => {
  const { t } = useTranslations();
  const { toast } = useToast({ variant: "web" });

  const { entitiesApi } = useRestApiProvider();

  const { entity } = useEntitySelectedProvider();
  const [updateEntity] = entitiesApi.useEditEntityMutation();

  const country = useMemo(
    () => countries.find((countryObj) => countryObj.iso === entity.country),
    [entity.country]
  );

  const handleCountryChange = async (nextCountry: Country) => {
    const response = await updateEntity({
      data: { country: nextCountry.iso },
      entityId: entity.id,
    });
    if (response && "data" in response) {
      toast(
        t({
          id: "workspace-page.workspace-country-was-updated",
          defaultMessage: "Workspace country was updated",
        })
      );
    }
  };

  return (
    <CountryPicker countryIso={country?.iso} onSelect={handleCountryChange}>
      <WorkspaceTile
        buttonText={t({
          id: "common.change",
          defaultMessage: "Change",
        })}
      >
        <div className="flex flex-col items-center gap-3 duration-500 group-hover:mt-[-90px]">
          <div className="h-10 w-10">
            <img
              src={country?.flag}
              className="h-full w-full"
              alt={country?.name}
            />
          </div>
          <div className="flex flex-col gap-1.5 text-center">
            <span className="font-medium text-dark-800">{country?.name}</span>
            <span className="text-sm text-[#828282]">
              {t({
                id: "workspace-page.workspace-country",
                defaultMessage: "Workspace country",
              })}
            </span>
          </div>
        </div>
      </WorkspaceTile>
    </CountryPicker>
  );
};
